/*eslint-disable */

import { bus } from '@/main';
import toast from '@/services/toast';
export default {
  name: 'q-ans-remove-popup',
  components: {},
  props: ['removeQueID'],
  data () {
    return {
      isSubmitted:false
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    getQueListAgainMethod(){
      this.$store.dispatch('getQAnsListWithOptionAction', {id: this.$route.params.qbankId})
    },
    confirmQueDeletePopupMethod(){
        this.isSubmitted = true
        this.$store.dispatch('removeQuestionByIdAction', {id:this.removeQueID}).then((res) => {
          toast.success(res.data.msg || "Request has been successfully submitted");  
          this.closeQueDeletePopupMethod()
          this.getQueListAgainMethod()
          this.isSubmitted = false
        }).catch((err) => {
          this.isSubmitted = false
        })
    },
    closeQueDeletePopupMethod(){
      bus.$emit('removeQuePopupStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
  }
}


